var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDirections = function SvgDirections(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 46,
    fill: "none",
    viewBox: "0 0 42 46",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#183E62",
    d: "m40.892 11.507-8.784 8.726a1.4 1.4 0 0 1-.904.385 1.4 1.4 0 0 1-.904-.385 1.235 1.235 0 0 1 0-1.796l6.588-6.545H20.096c-.775 0-1.292-.514-1.292-1.284s.517-1.283 1.292-1.283h16.792L30.3 2.78a1.235 1.235 0 0 1 0-1.797 1.254 1.254 0 0 1 1.808 0l8.784 8.727c.129.128.258.257.258.385.13.257.13.642 0 1.027 0 .128-.13.256-.258.385M21.904 33.708H5.113l6.587-6.545a1.235 1.235 0 0 0 0-1.796 1.254 1.254 0 0 0-1.808 0l-8.784 8.726c-.129.129-.258.257-.258.385-.13.257-.13.642 0 1.027.13.128.13.257.258.385l8.784 8.727a1.4 1.4 0 0 0 .904.385 1.4 1.4 0 0 0 .904-.385 1.235 1.235 0 0 0 0-1.797l-6.587-6.545h16.791c.775 0 1.292-.513 1.292-1.283s-.517-1.284-1.292-1.284"
  })));
};
export default SvgDirections;